module.exports = __webpack_public_path__ + "img/rewardBtn.9216a4ff.png";